import { useQuery } from "react-query";
import axiosClient from "./../../config/axiosClient";

const BASE_CACHEKEY_MAP = {
  offer: "offer-pitch",
  preoffer: "preoffer-pitch",
}

function pitchPath(pitchable_type, pitchable_id) {
  if(pitchable_type === "offer")
    return `/offers/${pitchable_id}/pitch`;
  
  if(pitchable_type === "preoffer")
    return `/preoffers/${pitchable_id}/pitch`;
  
  throw new Error("Invalid pitchable_type");
}

function pitchCustomerPath(pitchable_type, pitchable_id) {
  if(pitchable_type === "offer")
    return `/offers/${pitchable_id}/customers`

  if(pitchable_type === "preoffer")
    return `/preoffers/${pitchable_id}/customers`

  throw new Error("Invalid pitchable_type");
}

const usePitch = ({pitchable_type, pitchable_id}) => {
  return useQuery(
    [BASE_CACHEKEY_MAP[pitchable_type], pitchable_id],
    () => {
      return axiosClient
        .get(pitchPath(pitchable_type, pitchable_id))
    }, {
      initialData: {},
    }
  );
}

const updatePitch = ({pitchable_type, pitchable_id, values}) => {
  return axiosClient.put(pitchPath(pitchable_type, pitchable_id), values)
}

const addPitchSection = ({pitchable_type, pitchable_id, values}) =>{
  return axiosClient.post(`${pitchPath(pitchable_type, pitchable_id)}/pitch_sections`, values)
}

const updatePitchSection = ({pitchable_id, values}) =>{
  return axiosClient.put(`/pitch_sections/${pitchable_id}`, values)
}

const deletePitchSection = ({section_id, type}) => {
  return axiosClient.delete(`/pitch_sections/${section_id}`, {data: {type: type}})
}

// pitchable_type: preoffer | offer
const usePitchableCustomersList = ({pitchable_type, pitchable_id}) => {
  return useQuery(
    ['customers-list', pitchable_type, pitchable_id],
    () => {
      return axiosClient
        .get(pitchCustomerPath(pitchable_type, pitchable_id))
    }, {
      enabled: pitchable_id !== undefined
    }
  );  
}

// pitchable_type: preoffer | offer
const addCustomer = ({pitchable_type, pitchable_id, values}) => {
  return axiosClient.post(pitchCustomerPath(pitchable_type, pitchable_id), values);
}

const updateCustomer = ({customer_id, values}) => {
  return axiosClient.put(`/customers/${customer_id}`, values);
}

const deleteCustomer = ({customer_id}) => {
  return axiosClient.delete(`/customers/${customer_id}`);
}

export {
  BASE_CACHEKEY_MAP,
  usePitch,
  updatePitch,
  addPitchSection,
  updatePitchSection,
  deletePitchSection,
  usePitchableCustomersList,
  addCustomer,
  updateCustomer,
  deleteCustomer,
}
